var _circle, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowOnly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 18.5,
    r: 18.5,
    fill: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4051_2646",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 25,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.46094,
    y: 6.01172,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4051_2646)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.0879 18.7607H11.7109C11.4981 18.7607 11.3199 18.6889 11.1764 18.5452C11.0328 18.4017 10.9609 18.2236 10.9609 18.0107C10.9609 17.7979 11.0328 17.6197 11.1764 17.4762C11.3199 17.3326 11.4981 17.2607 11.7109 17.2607H23.0879L17.9187 12.0915C17.77 11.9428 17.6966 11.7688 17.6984 11.5695C17.7004 11.3702 17.7789 11.1929 17.9339 11.0377C18.0891 10.8929 18.2648 10.8179 18.4609 10.8127C18.6571 10.8076 18.8328 10.8826 18.9879 11.0377L25.3282 17.378C25.4219 17.4717 25.4879 17.5704 25.5262 17.6742C25.5647 17.7781 25.5839 17.8902 25.5839 18.0107C25.5839 18.1312 25.5647 18.2434 25.5262 18.3472C25.4879 18.4511 25.4219 18.5498 25.3282 18.6435L18.9879 24.9837C18.8494 25.1222 18.6779 25.1931 18.4734 25.1962C18.2689 25.1994 18.0891 25.1286 17.9339 24.9837C17.7789 24.8286 17.7014 24.6504 17.7014 24.4492C17.7014 24.2479 17.7789 24.0697 17.9339 23.9145L23.0879 18.7607Z",
    fill: "#2D76FD"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowOnly);
export default __webpack_public_path__ + "static/media/arrow_only.61cc27aa6783e151ad57431957f691d8.svg";
export { ForwardRef as ReactComponent };